import { createContext } from 'react';

var focusScope = /*#__PURE__*/createContext(undefined);

export { focusScope };
//# sourceMappingURL=scope.js.map
